// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-index-productDay-babox{width:100%}.pages-index-productDayWrapper-brrid.pages-index-mobile-mdpxo{margin-left:-16px;margin-right:-16px}.pages-index-productsBlock3-gogfh{margin-bottom:24px}.pages-index-productsBlock3-gogfh:last-child{margin-bottom:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"productDay": "pages-index-productDay-babox",
	"productDayWrapper": "pages-index-productDayWrapper-brrid",
	"mobile": "pages-index-mobile-mdpxo",
	"productsBlock3": "pages-index-productsBlock3-gogfh"
};
module.exports = ___CSS_LOADER_EXPORT___;
